var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "16.024 53.162 407.119 117.734",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsBx: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgba(255, 255, 255, 0)",
      stroke: "rgb(219, 49, 49)",
      strokeWidth: 10
    },
    cx: 219.53,
    cy: 112.033,
    rx: 198.494,
    ry: 53.83
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(219, 49, 49)",
      strokeLinecap: "round",
      strokeWidth: 5
    },
    x1: 260.194,
    y1: 117.653,
    x2: 414.815,
    y2: 117.717
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(219, 49, 49)",
      strokeLinecap: "round",
      strokeWidth: 5
    },
    x1: 259.85,
    y1: 105.597,
    x2: 414.734,
    y2: 105.608
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(219, 49, 49)",
      strokeLinecap: "round",
      strokeWidth: 5
    },
    x1: 24.622,
    y1: 106.453,
    x2: 179.423,
    y2: 106.392
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(219, 49, 49)",
      strokeLinecap: "round",
      strokeWidth: 5
    },
    x1: 24.887,
    y1: 118.106,
    x2: 179.178,
    y2: 118.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(219, 49, 49)",
      strokeWidth: 3,
      fill: "rgb(219, 49, 49)"
    },
    cx: 219.583,
    cy: 112.029,
    rx: 40,
    ry: 40.001
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgba(255, 255, 255, 0)",
      fill: "none",
      strokeWidth: "2.5px"
    },
    cx: 219.53,
    cy: 112.034,
    rx: 198.494,
    ry: 53.831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 178.38 101.365 Q 184.798 88.209 191.215 101.365 L 207.158 134.048 Q 213.576 147.204 200.741 147.204 L 168.854 147.204 Q 156.019 147.204 162.437 134.048 Z",
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%",
      strokeWidth: 0,
      stroke: "rgb(219, 49, 49)",
      paintOrder: "fill",
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(0, 1, -1, 0, 38.785999, -8.966498)",
    bxShape: "triangle 156.019 88.209 57.557 58.995 0.5 0.223 1@1ee91c17"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLogo);
export default __webpack_public_path__ + "static/media/title-logo.4e824da88f49ba11efccb1a97bb839ff.svg";
export { ForwardRef as ReactComponent };